import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  skip(event) {
    const main = document.querySelector("main")
    if (!main) return
    event.preventDefault()
    main.setAttribute("tabindex", "-1")
    main.focus()
    main.scrollIntoView({ behavior: "instant", block: "start" })
  }
}
